<template>
  <div>
    <div id='travellerSection'>
      <div id='traveller2'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 2</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller2_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller2_firstname' aria-required="true" type='text' class='form-control' id='traveller2_firstname' :placeholder='$t("text.placeholderFirstName")' maxlength="50"/>
            </div>
            <div class='col-6'>
              <label for='traveller2_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller2_lastname' aria-required="true" type='text' class='form-control' id='traveller2_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller2_firstname' class='feedback' id='err_traveller2_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller2_lastname' class='feedback' id='err_traveller2_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller2_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller2_dob' class='form-control' readonly='readonly' :value='traveller2_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller3'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 3</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller3_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller3_firstname' aria-required="true" type='text' class='form-control' id='traveller3_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller3_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller3_lastname' aria-required="true" type='text' class='form-control' id='traveller3_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller3_firstname' class='feedback' id='err_traveller3_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller3_lastname' class='feedback' id='err_traveller3_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller3_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller3_dob' class='form-control' readonly='readonly' :value='traveller3_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller4'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 4</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller4_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller4_firstname' aria-required="true" type='text' class='form-control' id='traveller4_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller4_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller4_lastname' aria-required="true" type='text' class='form-control' id='traveller4_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller4_firstname' class='feedback' id='err_traveller4_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller4_lastname' class='feedback' id='err_traveller4_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller4_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller4_dob' class='form-control' readonly='readonly' :value='traveller4_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller5'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 5</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller5_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller2_firstname' aria-required="true" type='text' class='form-control' id='traveller5_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller5_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller5_lastname' aria-required="true" type='text' class='form-control' id='traveller5_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller5_firstname' class='feedback' id='err_traveller5_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller5_lastname' class='feedback' id='err_traveller5_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller5_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller5_dob' class='form-control' readonly='readonly' :value='traveller5_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller6'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 6</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller6_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller6_firstname' aria-required="true" type='text' class='form-control' id='traveller6_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller6_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller6_lastname' aria-required="true" type='text' class='form-control' id='traveller6_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller6_firstname' class='feedback' id='err_traveller6_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller6_lastname' class='feedback' id='err_traveller6_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller6_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller6_dob' class='form-control' readonly='readonly' :value='traveller6_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller7'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 7</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller7_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller2_firstname' aria-required="true" type='text' class='form-control' id='traveller7_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller7_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller2_lastname' aria-required="true" type='text' class='form-control' id='traveller7_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller7_firstname' class='feedback' id='err_traveller7_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller7_lastname' class='feedback' id='err_traveller7_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller7_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller7_dob' class='form-control' readonly='readonly' :value='traveller7_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller8'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 8</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller8_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller8_firstname' aria-required="true" type='text' class='form-control' id='traveller8_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller8_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller8_lastname' aria-required="true" type='text' class='form-control' id='traveller8_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller8_firstname' class='feedback' id='err_traveller8_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller8_lastname' class='feedback' id='err_traveller8_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller8_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller8_dob' class='form-control' readonly='readonly' :value='traveller8_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller9'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 9</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller9_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller9_firstname' aria-required="true" type='text' class='form-control' id='traveller9_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller9_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller9_lastname' aria-required="true" type='text' class='form-control' id='traveller9_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller9_firstname' class='feedback' id='err_traveller9_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller9_lastname' class='feedback' id='err_traveller9_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller9_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller9_dob' class='form-control' readonly='readonly' :value='traveller9_dob'/>
            </div>
          </div>
        </fieldset>
      </div>

      <div id='traveller10'>
        <fieldset>
          <legend class='textTraveller'>{{$t("text.traveller")}} 10</legend>
          <div class='form-group row' >
            <div class='col-6'>
              <label for='traveller10_firstname' v-html='$t("text.firstname")'></label><br/>
              <input v-model='traveller10_firstname' aria-required="true" type='text' class='form-control' id='traveller10_firstname' :placeholder='$t("text.placeholderFirstName")'  maxlength="50" />
            </div>
            <div class='col-6'>
              <label for='traveller10_lastname' v-html='$t("text.lastname")'></label>
              <input v-model='traveller10_lastname' aria-required="true" type='text' class='form-control' id='traveller10_lastname' :placeholder='$t("text.placeholderLastName")'  maxlength="50" />
            </div>
          </div>
          <div class='form-row'>
            <div class='col-6'>
              <span for='traveller10_firstname' class='feedback' id='err_traveller10_firstname' tabindex="-1"></span>
            </div>
            <div class='col-6'>
              <span for='traveller10_lastname' class='feedback' id='err_traveller10_lastname' tabindex="-1"></span>
            </div>
          </div>
          <div class='form-group row' >
            <div class='col-12'>
              <label for='traveller10_dob' v-html='$t("text.dateofbirth")'></label>
              <input id='traveller10_dob' class='form-control' readonly='readonly' :value='traveller10_dob'/>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import { addNavProceedCheck } from "../utils/navProceed.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField, callValidationStatusOnBlur } from "../utils/validation.js";

import Datepicker from "vuejs-datepicker";
const dateYesterday = new Date();
dateYesterday.setDate(dateYesterday.getDate() - 1);
const date15DaysAgo = new Date();
date15DaysAgo.setDate(date15DaysAgo.getDate() - 15);
const date40YearsAgo = new Date();
date40YearsAgo.setDate(date40YearsAgo.getDate() - 40 * 365);

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      disabledTripDates: {
        to: dateYesterday
      },
      disabledBirthDates: {
        from: date15DaysAgo
      },
      openBirthDates: date40YearsAgo,
      province_full: this.$store.state.province_full,
    }
  },
  computed: {
    tripStart: {
      get() {
        return this.$store.state.tripStart;
      },
      set(newValue) {
        validateField(document.getElementById("tripStart"), newValue, validationRules());
      }
    },
    traveller2_firstname: {
      get() {
        return this.$store.state.traveller2_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller2_firstname"), newValue, validationRules());
      }
    },
    traveller2_lastname: {
      get() {
        return this.$store.state.traveller2_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller2_lastname"), newValue, validationRules());
      }
    },
    traveller2_dob: {
      get() {
        return this.$store.state.traveller2_dob;
      }
    },
    traveller3_firstname: {
      get() {
        return this.$store.state.traveller3_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller3_firstname"), newValue, validationRules());
      }
    },
    traveller3_lastname: {
      get() {
        return this.$store.state.traveller3_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller3_lastname"), newValue, validationRules());
      }
    },
    traveller3_dob: {
      get() {
        return this.$store.state.traveller3_dob;
      }
    },
    traveller4_firstname: {
      get() {
        return this.$store.state.traveller4_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller4_firstname"), newValue, validationRules());
      }
    },
    traveller4_lastname: {
      get() {
        return this.$store.state.traveller4_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller4_lastname"), newValue, validationRules());
      }
    },
    traveller4_dob: {
      get() {
        return this.$store.state.traveller4_dob;
      }
    },
    traveller5_firstname: {
      get() {
        return this.$store.state.traveller5_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller5_firstname"), newValue, validationRules());
      }
    },
    traveller5_lastname: {
      get() {
        return this.$store.state.traveller5_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller5_lastname"), newValue, validationRules());
      }
    },
    traveller5_dob: {
      get() {
        return this.$store.state.traveller5_dob;
      }
    },
    traveller6_firstname: {
      get() {
        return this.$store.state.traveller6_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller6_firstname"), newValue, validationRules());
      }
    },
    traveller6_lastname: {
      get() {
        return this.$store.state.traveller6_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller6_lastname"), newValue, validationRules());
      }
    },
    traveller6_dob: {
      get() {
        return this.$store.state.traveller6_dob;
      }
    },
    traveller7_firstname: {
      get() {
        return this.$store.state.traveller7_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller7_firstname"), newValue, validationRules());
      }
    },
    traveller7_lastname: {
      get() {
        return this.$store.state.traveller7_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller7_lastname"), newValue, validationRules());
      }
    },
    traveller7_dob: {
      get() {
        return this.$store.state.traveller7_dob;
      }
    },
    traveller8_firstname: {
      get() {
        return this.$store.state.traveller8_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller8_firstname"), newValue, validationRules());
      }
    },
    traveller8_lastname: {
      get() {
        return this.$store.state.traveller8_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller8_lastname"), newValue, validationRules());
      }
    },
    traveller8_dob: {
      get() {
        return this.$store.state.traveller8_dob;
      }
    },
    traveller9_firstname: {
      get() {
        return this.$store.state.traveller9_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller9_firstname"), newValue, validationRules());
      }
    },
    traveller9_lastname: {
      get() {
        return this.$store.state.traveller9_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller9_lastname"), newValue, validationRules());
      }
    },
    traveller9_dob: {
      get() {
        return this.$store.state.traveller9_dob;
      }
    },
    traveller10_firstname: {
      get() {
        return this.$store.state.traveller10_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller10_firstname"), newValue, validationRules());
      }
    },
    traveller10_lastname: {
      get() {
        return this.$store.state.traveller10_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller10_lastname"), newValue, validationRules());
      }
    },
    traveller10_dob: {
      get() {
        return this.$store.state.traveller10_dob;
      }
    }
  },
  mounted() {
    // Show/hide the traveller fields depending on # selected
    const rowList = document.getElementById("travellerSection").children;
    let rowsToShow = this.$store.state.numberOfTravellers-1;
    if (rowsToShow === "") {
      rowsToShow = 1;
    }
    for (let x = 0; x < 9; x++) {
      if (x < rowsToShow) {
        rowList[x].classList.remove("d-none");
      } else {
        rowList[x].classList.add("d-none");
      }
    }

    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });
    
    // Have fields begin validation on Blur, instead of when navigating to next page.
    callValidationStatusOnBlur(validationRules());

    // Check if Next button should be enabled or disabled.
    const targets = [
      document.getElementById("traveller2_firstname"),
      document.getElementById("traveller2_lastname"),
      document.getElementById("traveller3_firstname"),
      document.getElementById("traveller3_lastname"),
      document.getElementById("traveller4_firstname"),
      document.getElementById("traveller4_lastname"),
      document.getElementById("traveller5_firstname"),
      document.getElementById("traveller5_lastname"),
      document.getElementById("traveller6_firstname"),
      document.getElementById("traveller6_lastname"),
      document.getElementById("traveller7_firstname"),
      document.getElementById("traveller7_lastname"),
      document.getElementById("traveller8_firstname"),
      document.getElementById("traveller8_lastname"),
      document.getElementById("traveller9_firstname"),
      document.getElementById("traveller9_lastname"),
      document.getElementById("traveller10_firstname"),
      document.getElementById("traveller10_lastname"),
    ];
    this.$nextTick( () => {
      addNavProceedCheck(targets);
    });
  },
}
</script>

<style>
fieldset {
  margin-top:25px;
}
</style>